import { RefCallBack } from 'react-hook-form';
import { Radio, RadioGroup } from 'rsuite';
import styles from '../SetupIPADadosDeConcorrencia.module.scss';

type RadioOption<T extends string> = {
  value: T;
  title: string;
  subtitle: string;
};

type OptionRadioGroupProps<T extends string> = {
  options: ReadonlyArray<RadioOption<T>>;
  name: string;
  value: T;
  onChange: (value: T) => void;
  onBlur: () => void;
  inputRef: RefCallBack;
};

export const OptionRadioGroup = <T extends string>({ options, name, value, onChange, onBlur, inputRef }: OptionRadioGroupProps<T>) => (
  <RadioGroup ref={inputRef} name={name} value={value} onChange={selected => onChange(selected as T)} onBlur={onBlur}>
    {options.map(option => (
      <div key={option.value} className={styles['setup-ipa__price-preference-competitor__option-radio']}>
        <Radio value={option.value}>
          <div className={styles['text-container']}>
            <h4>{option.title}</h4>
            <span>{option.subtitle}</span>
          </div>
        </Radio>
      </div>
    ))}
  </RadioGroup>
);
